// @flow
'use strict';

import AbasInformacoes from './abas_informacoes';

export default AbasInformacoes;
